import { ILocationSuggest, TBoundedBy, TSuggestLocationType } from '@cian/geosuggest-widget/es/types';

import { ISuggestItemDataClassSchema } from '../../repositories/geo-suggest/entities/entities/SuggestItemDataClassSchema';

export const mapDistricts = (districts: ISuggestItemDataClassSchema[]): ILocationSuggest[] => {
  return districts.map(district => ({
    regionId: district.regionId as number,
    fullName: district.fullName,
    id: district.id,
    matches: district.matches as TBoundedBy,
    name: district.name,
    type: district.type as unknown as TSuggestLocationType,
  }));
};
